'use strict'

var offCanvas = new OffCanvas({
  debug: false,
  overlay: true,
});